import React from 'react'
import DiagnosticSuccess from '../Components/DiagnosticSuccess/DiagnosticSuccess'

const DiagnosticSuccessView = () => {
  return (
    <div>
        <DiagnosticSuccess />
    </div>
  )
}

export default DiagnosticSuccessView